<template>
  <f7-page>
    <f7-navbar :title="$t('title.makeRequest')" :back-link="$t('action.back')"/>
    <f7-list ref="form" :id="formId" class="form-store-data" form>
      <f7-list-input
              :label="$t('label.amount')"
              :input="false"
      >
        <money v-model="request.amount" name="amount" maxlength="9" v-bind="money" @focusout="validateAmount = true"
               slot="input"/>
        <div v-if="validateAmount && request.amount <= 0" class="item-input-error-message">
          {{$t('validation.amount')}}
        </div>
      </f7-list-input>

      <f7-list-input :label="$t('label.spendReason')"
                     :input="false"
                     :error-message="$t('validation.reason')"
                     v-if="$store.state.beta.enabled"
      >
        <!-- v-if because otherwise it gets invisibly recreated every time we type in the oldcontent (and steals focus) -->
        <tag-entry v-model="request.reason.tags" slot="input"/>
      </f7-list-input>
      <f7-list-input v-beta.oldContent
                     :label="$t('label.spendReason')"
                     type="text"
                     :value="request.reason.text"
                     @input="request.reason.text = $event.target.value"
                     required validate clear-button

      />

      <f7-list-input v-beta.oldContent
                     :label="$t('label.addNote')"
                     type="text" name="notes" :value="request.notes" @input="request.notes = $event.target.value"
                     clear-button
      />

      <f7-list-input v-beta
                     :label="$t('label.addNote')"
                     type="text" name="comment" :value="request.comment" @input="request.comment = $event.target.value"
                     clear-button
      />

      <f7-list-input type="select"
                     :label="$tc('label.budget', 1)"
                     name="potId"
                     :value="request.potId"
                     @input="request.potId = parseInt($event.target.value)"
                     :error-message="$t('validation.chooseBudget')"
                     required validate
      >
        <option value="unset" disabled>{{$t('placeholder.chooseBudget')}}</option>
        <option v-for="budget in activeBudgets" :key="budget.potId" :value="budget.potId">{{budget.name}}</option>
      </f7-list-input>

      <f7-block>
        <button type="submit" class="button button-big button-fill" @click.prevent="submit">
          {{$t('action.submitRequest')}}
        </button>
      </f7-block>
    </f7-list>
  </f7-page>
</template>

<script>
  import api from 'aio-api'
  import helpers from '@/utils/helpers'
  import TagEntry from '@/components/TagEntry'
  import {Money} from 'v-money'

  export default {
    name: 'make-request',
    components: {TagEntry, Money},
    created () {
      this.$store.dispatch('budgets/fetch')
    },
    data () {
      return {
        formId: 'make-request',
        request: {
          amount: '',
          reason: {
            tags: [],
            text: '',
          },
          potId: 'unset',
          notes: '',
        },
        validateAmount: false,
      }
    },
    methods: {
      validate (request) {
        this.$refs.form.$el.checkValidity()
        this.validateAmount = true
        const errors = []
        if (request.amount <= 0) errors.push(this.$t('validation.amount'))
        if (!request.reason) errors.push(this.$t('validation.reason'))
        if (request.potId == null || request.potId === 'unset') errors.push(this.$t('validation.chooseBudget'))
        return {
          valid: errors.length === 0,
          errors,
        }
      },
      async submit () {
        const request = this.submittableRequest
        const {errors, valid} = this.validate(request)
        if (!valid) {
          this.$f7.dialog.alert(errors.join('<br>'), '')
          return
        }
        try {
          request.reqType = 'one_off'
          request.currency = this.activeBudgets.find(b => b.potId === request.potId).currency
          if (this.$store.state.beta.enabled) {
            request.tags = this.request.reason.tags.map(t => t.name)
          }

          await api.request.create(request)

          // we might have added a pseudo-tag when tagging the request, refresh tags
          // really we should have some kind of websocket-based mechanism to push notifications about stuff like this
          this.$store.dispatch('tags/fetch')

          this.$f7.dialog.alert(this.$t('dialog.makeRequestSuccess'), '', () => {
            this.$store.dispatch('requests/fetchOwn')
            this.$f7.form.removeFormData(this.formId)
            this.goBack()
          })
        } catch (error) {
          //TODO: i18n error message
          this.$f7.dialog.alert(error.response.data, '')
        }
      },
    },
    computed: {
      f7formId () {
        return `f7form-${this.formId}`
      },
      submittableRequest () {
        const request = {...this.request}

        if (this.$store.state.beta.enabled) {
          request.reason = request.reason.tags.map(t => t.name).join(' ')
        } else {
          request.reason = request.reason.text
        }

        return request
      },
    },
    mixins: [helpers],
  }
</script>

<style scoped>
</style>
